// TODO:
// Render elements at cart
// Include cart render functions
class CustomEngraving2026Text extends HTMLElement {
  constructor() {
    super();
    this.customizationOptions = document.querySelector(
      "custom-engraving-2026-customization-options",
    );
    this.customEngraving2026 = document.querySelector("custom-engraving-2026");
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    this.fontFamily = this.querySelector("#engraving-text-font");
    this.lineOne = this.querySelector("#engraving-text-line-one");
    this.lineTwo = this.querySelector("#engraving-text-line-two");
    this.lineThree = this.querySelector("#engraving-text-line-three");
    this.lineInputs = [this.lineOne, this.lineTwo, this.lineThree];
    this.consent = this.querySelector("#consent-engraving-custom-text");
    this.status = this.querySelector("#engraving-text-form-status");

    this.previewLines = document.querySelector(
      "#engraving-preview-placeholder--text",
    );

    this.optionsScreenBtn = this.querySelector(
      ".engraving-customization--prev-btn",
    );

    this.optionsScreenBtn.addEventListener("click", () => {
      this.customizationOptions.scrollToOptionsScreen();
    });

    this.submitButton = this.querySelector("#engraving-text-submit");
    this.submitButtonLabel = this.submitButton.querySelector("span");

    this.loadComponent();
    document.addEventListener(
      "custom-engraving-2026",
      this.customEngraving2026EventHandler.bind(this),
    );

    this.form.addEventListener("submit", this.formSubmit.bind(this));
    this.fontFamily.addEventListener(
      "change",
      this.changeFontFamily.bind(this),
    );
    this.changeFontFamily({ target: this.fontFamily });
    this.lineInputs.forEach((input, index) => {
      input.addEventListener("input", (event) => {
        this.clearValidation();
        this.updateCharacterCount(event.target);
        this.writeText(index + 1, event.target.value);
      });
    });
    this.consent.addEventListener("change", this.clearValidation.bind(this));
  }
  customEngraving2026EventHandler(event) {
    this.loadComponent(event.detail);
  }

  loadComponent(eventProductEngravingSettings = false) {
    const settings = eventProductEngravingSettings
      ? eventProductEngravingSettings
      : this.customEngraving2026.currentProductEngravingSettings;
    if (!settings) return;
    const { engravingService, currentProductInfo } = settings;

    this.engravingService = engravingService;
    this.isEditing = this.customEngraving2026.cartContext?.isEditing === true;
    this.form.reset();
    this.clearValidation();
    this.lineInputs.forEach((input, index) => {
      const enabled = index < engravingService.engravingLines;
      input.disabled = !enabled;
      input.closest("label").hidden = !enabled;
      input.value = "";
      this.updateCharacterCount(input);
      this.writeText(index + 1);
      this.previewLines.children[index].hidden = !enabled;
    });
    this.changeFontFamily({ target: this.fontFamily });
    this.setSubmitting(false);
    this.setEngravingVariantId(engravingService);
    this.setCurrentProductVariantId(currentProductInfo);
    this.setEngravingPrice(engravingService);
  }

  setCurrentProductVariantId({ variantId }) {
    this.form.querySelector("input[data-pdp-variant-id]").value = variantId;
  }

  setEngravingVariantId({ engravingServiceProduct }) {
    this.form.querySelector("input[data-engraving-service-variant-id]").value =
      engravingServiceProduct;
  }

  setEngravingPrice({ textPrice }) {
    this.querySelector("input[data-engraving-service-price]").value = textPrice;
  }

  writeText(line = 0, text = "") {
    if (line == 0) return;

    if (line == 1)
      this.customizationOptions.placeholderText.querySelector(
        "p:first-of-type",
      ).textContent = text.length ? text : "Line 1";
    if (line == 2)
      this.customizationOptions.placeholderText.querySelector(
        "p:nth-child(2)",
      ).textContent = text.length ? text : "Line 2";
    if (line == 3)
      this.customizationOptions.placeholderText.querySelector(
        "p:last-of-type",
      ).textContent = text.length ? text : "Line 3";
  }

  changeFontFamily(event) {
    const selected = event.target.selectedOptions[0];
    if (!selected) return;
    const preview = this.customizationOptions.placeholderText;
    preview.style.fontFamily = selected.dataset.family || "inherit";
    preview.style.fontWeight = selected.dataset.weight || "400";
    preview.style.fontStyle = selected.dataset.style || "normal";
  }

  prefillForEdit(properties = {}) {
    this.form.reset();
    this.clearValidation();
    this.isEditing = true;

    const existingFont = properties._engraving_font || "";
    const existingTtf = properties._engraving_font_ttf || "";
    const fontOptions = Array.from(this.fontFamily.options);
    const fontOption = fontOptions.find(
      (option) => existingTtf && option.dataset.ttf === existingTtf,
    ) || fontOptions.find(
      (option) => existingFont && [option.value, option.dataset.fontName].includes(existingFont),
    );
    if (existingFont || existingTtf) this.fontFamily.value = fontOption?.value || "";
    this.changeFontFamily({ target: this.fontFamily });

    const values = [
      properties._Line1 || "",
      properties._Line2 || "",
      properties._Line3 || "",
    ];
    this.lineInputs.forEach((input, index) => {
      input.value = input.disabled ? "" : values[index];
      this.updateCharacterCount(input);
      this.writeText(index + 1, input.value);
    });

    this.consent.checked = false;
    this.setSubmitting(false);
    if ((existingFont || existingTtf) && !fontOption) {
      this.showMessage("Please choose a font for your engraving.", this.fontFamily);
    }
  }

  async formSubmit(event) {
    event.preventDefault();
    if (this.isSubmitting || !this.validateForm()) return;

    const formData = new FormData(this.form);
    const formEntries = Object.fromEntries(formData.entries());

    if (!this.hasRequiredProductData(formEntries)) {
      this.showMessage(
        "Engraving is temporarily unavailable for this watch. Please close this window and try again.",
      );
      return;
    }

    const cartSettings = this.buildCartSettings(formEntries);
    const cart = document.querySelector("cart-drawer");
    const cartRequest = this.customEngraving2026.buildCartRequest(
      cartSettings,
      cart,
    );

    this.setSubmitting(true);

    try {
      const request = await fetch(
        window.Shopify.routes.root + cartRequest.endpoint,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cartRequest.payload),
        },
      );

      const response = await request.json().catch(() => null);
      if (!request.ok) {
        const error = new Error(response?.description || `${cartRequest.endpoint} ${request.status}`);
        if (request.status === 422) error.customerMessage = response?.description;
        throw error;
      }
      if (cartRequest.endpoint === "cart/add.js" && !response?.items?.length) {
        throw new Error("The cart response did not include an added item.");
      }

      this.customEngraving2026.renderCartResponse(
        response,
        cart,
        "custom-engraving-2026-text",
      );
      this.resetElements();
      document.querySelector("#custom-engraving-2026--dialog")?.close();
    } catch (error) {
      console.error("Custom text engraving add-to-cart failed:", error);
      this.showMessage(
        error.customerMessage || "We couldn't add the engraving. Please check your connection and try again.",
      );
    } finally {
      this.setSubmitting(false);
    }
  }

  buildCartSettings(formEntries) {
    const selectedFont = this.fontFamily.selectedOptions[0];
    const cartSettings = {
      id: `${formEntries["pdp-variant-id"]}`,
      quantity: 1,
      properties: {
        _engraving_service_variant_id: `gid://shopify/ProductVariant/${formEntries["engraving-service-variant-id"]}`,
        _engraving_service_price: Number(this.engravingService.textPrice).toFixed(2),
        _engraving_mode: "text",
        _engraving_type: this.engravingService.engravingType,
        _engraving_customization_option: `custom-text`,
        _engraving_font: selectedFont.dataset.fontName,
        _engraving_font_ttf: selectedFont.dataset.ttf || "",
        _Line1: (formEntries["engraving-text-line-one"] || "").trim(),
        _Line2: (formEntries["engraving-text-line-two"] || "").trim(),
        _Line3: (formEntries["engraving-text-line-three"] || "").trim(),
      },
    };

    return cartSettings;
  }

  validateForm() {
    this.clearValidation();

    const selectedFont = this.fontFamily.selectedOptions[0];
    if (!selectedFont?.dataset.fontName || !selectedFont.dataset.ttf) {
      this.showMessage("Please choose a font for your engraving.", this.fontFamily);
      return false;
    }

    for (const [index, input] of this.lineInputs.entries()) {
      if (input.disabled) continue;
      const value = input.value.trim();
      const isRequiredLine = index === 0;

      if (input.value.length > 22) {
        input.setCustomValidity(
          `${isRequiredLine ? "Line One" : `Line ${index + 1}`} must be 22 characters or fewer.`,
        );
      } else if ((isRequiredLine || value.length) && value.length < 3) {
        input.setCustomValidity(
          `${isRequiredLine ? "Line One" : `Line ${index + 1}`} must contain at least 3 characters.`,
        );
      }

      if (!input.checkValidity()) {
        const message = input.validity.patternMismatch
          ? "Use letters, numbers, and standard punctuation only. The symbols <, >, °, and @ aren't supported."
          : input.validationMessage;
        this.showMessage(message, input);
        return false;
      }
    }

    if (!this.consent.checked) {
      this.consent.setCustomValidity(
        "Please authorize the engraving text before continuing.",
      );
      this.showMessage(
        "Please check the authorization box before adding the engraving.",
        this.consent,
      );
      return false;
    }

    return true;
  }

  clearValidation() {
    this.lineInputs?.forEach((input) => {
      input.setCustomValidity("");
      input.removeAttribute("aria-invalid");
    });
    this.consent?.setCustomValidity("");
    this.consent?.removeAttribute("aria-invalid");
    this.fontFamily?.removeAttribute("aria-invalid");

    if (this.status) {
      this.status.hidden = true;
      this.status.textContent = "";
    }
  }

  showMessage(message, control = null) {
    if (!this.status) return;
    this.status.textContent = message;
    this.status.hidden = false;
    control?.setAttribute("aria-invalid", "true");
    this.status.focus();
  }

  updateCharacterCount(input) {
    const counterId = input.getAttribute("aria-describedby");
    const counter = counterId ? this.querySelector(`#${counterId}`) : null;
    if (counter) {
      counter.textContent = `${input.value.length}/22`;
      counter.classList.toggle("is-over-limit", input.value.length > 22);
    }
  }

  hasRequiredProductData(formEntries) {
    return Boolean(
      formEntries["pdp-variant-id"] &&
        formEntries["engraving-service-variant-id"],
    );
  }

  setSubmitting(isSubmitting) {
    this.isSubmitting = isSubmitting;
    this.form.setAttribute("aria-busy", isSubmitting ? "true" : "false");
    this.submitButton.disabled = isSubmitting;
    this.submitButtonLabel.textContent = isSubmitting
      ? "Adding…"
      : this.isEditing
        ? `Update Engraving • $${this.engravingService?.textPrice ?? 29}`
        : "Add Engraving";
  }

  resetElements() {
    this.form.reset();
    this.clearValidation();
    this.lineInputs.forEach((input) => this.updateCharacterCount(input));
    this.writeText(1);
    this.writeText(2);
    this.writeText(3);
    this.changeFontFamily({ target: this.fontFamily });
    this.isEditing = false;
    this.setSubmitting(false);
    this.customizationOptions.resetElements();
  }

  disconnectedCallback() {}
}
customElements.define("custom-engraving-2026-text", CustomEngraving2026Text);
